import { render, staticRenderFns } from "./PermissionRole.vue?vue&type=template&id=06f38010&"
import script from "./PermissionRole.vue?vue&type=script&lang=js&"
export * from "./PermissionRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\laravel\\rawal\\rawal-laravel\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06f38010')) {
      api.createRecord('06f38010', component.options)
    } else {
      api.reload('06f38010', component.options)
    }
    module.hot.accept("./PermissionRole.vue?vue&type=template&id=06f38010&", function () {
      api.rerender('06f38010', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/PermissionRole.vue"
export default component.exports